import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDatos } from '../contexts/DatosContext';
import { ExploradorRecursos } from '../components/biblioteca/ExploradorRecursos';
import { FichaRecurso } from '../components/biblioteca/FichaRecurso';
import { Modal } from '../components/ui/Modal';
import { Boton } from '../components/ui/Boton';
import { TituloSeccion } from '../components/ui/Tarjeta';
import { Aviso } from '../components/ui/Aviso';
import type { Recurso } from '../types';
import { ejercicioDesdeRecurso } from '../utils/clase';
import { CATALOGO } from '../data/catalogo';
export function Biblioteca() {
  const {
    recursos,
    favoritos,
    alternarFavorito,
    recientes,
    registrarReciente,
    borrador,
    guardarBorrador,
    notificar
  } = useDatos();
  const navegar = useNavigate();
  const [ficha, setFicha] = useState<Recurso | null>(null);
  const [aAgregar, setAAgregar] = useState<Recurso | null>(null);
  const abrirFicha = (r: Recurso) => {
    registrarReciente(r.id);
    setFicha(r);
  };
  const agregarABloque = (uidBloque: string) => {
    if (!borrador || !aAgregar) return;
    const actualizado = {
      ...borrador,
      bloques: borrador.bloques.map(b => b.uid === uidBloque ? {
        ...b,
        ejercicios: [...b.ejercicios, ejercicioDesdeRecurso(aAgregar)]
      } : b)
    };
    guardarBorrador(actualizado);
    notificar(`${aAgregar.id} agregado a “${borrador.bloques.find(b => b.uid === uidBloque)?.nombre}”.`);
    setAAgregar(null);
    setFicha(null);
  };
  return <div className="space-y-5" data-id="element-454" data-mp="40drpg6eo7km">
      <TituloSeccion nivel={1} descripcion={`Catálogo base de ${CATALOGO.length} recursos con objetivo, prerrequisitos, regresión, progresión, clave docente y seguridad.`} data-id="element-455" data-mp="8sossmcvtzer">
        Biblioteca
      </TituloSeccion>

      {!borrador && <Aviso tipo="info" titulo="Sin clase activa" data-id="element-456" data-mp="ip9zrd8gpkl8">
          Para usar “Agregar a clase activa”, creá o continuá un borrador desde Nueva clase.
        </Aviso>}

      <ExploradorRecursos recursos={recursos} favoritos={favoritos} recientes={recientes} alternarFavorito={alternarFavorito} onAbrirFicha={abrirFicha} nivelClase={borrador?.nivel} accionSecundaria={borrador ? r => {
      registrarReciente(r.id);
      setAAgregar(r);
    } : undefined} etiquetaAccion="Agregar a clase activa" data-id="element-457" data-mp="3u8hpeu00tlxw" />

      <FichaRecurso recurso={ficha} abierto={Boolean(ficha)} onCerrar={() => setFicha(null)} favorito={ficha ? favoritos.includes(ficha.id) : false} onFavorito={() => ficha && alternarFavorito(ficha.id)} onAgregarAClase={borrador && ficha ? () => setAAgregar(ficha) : undefined} onCopiar={ficha ? () => {
      navegar('/personalizados', {
        state: {
          copiaDe: ficha.id
        }
      });
    } : undefined} recursos={recursos} onAbrirRelacionado={abrirFicha} data-id="element-458" data-mp="bui7dynsp6ci" />

      <Modal abierto={Boolean(aAgregar && borrador)} titulo="Elegí el bloque" descripcion={aAgregar ? `${aAgregar.id} · ${aAgregar.nombre}` : undefined} onCerrar={() => setAAgregar(null)} ancho="sm" acciones={<Boton variante="contorno" onClick={() => setAAgregar(null)} data-id="element-460" data-mp="y8fh6rmuhdab">
            Cancelar
          </Boton>} data-id="element-459" data-mp="180tnlxovb82t">
        <ul className="space-y-2" data-id="element-461" data-mp="oc2re4uf7jku">
          {borrador?.bloques.map(b => <li key={b.uid} data-id="element-462" data-mp="o9zrmt3guc2x">
              <button type="button" onClick={() => agregarABloque(b.uid)} className="flex min-h-[44px] w-full items-center justify-between gap-3 rounded-xl border border-linea px-3 py-2 text-left text-sm font-semibold text-tinta hover:border-vino hover:bg-vino/5" data-id="element-463" data-mp="ad30eqjfqsli">
                <span data-id="element-464" data-mp="29oclbn3983s4">{b.nombre}</span>
                <span className="text-xs text-tinta-tenue" data-id="element-465" data-mp="29nb6d7j4ax54">
                  {b.minutos} min · {b.ejercicios.length} ejercicios
                </span>
              </button>
            </li>)}
        </ul>
      </Modal>
    </div>;
}